import { isCanceledOrDeleted } from "@stores/purchases/utils";
import { ReactElement } from "react";
import { IPurchaseCardProps } from "../types";
import PurchaseCard, { PurchaseCardHeader } from "../PurchaseCard/PurchaseCard";
import { PurchaseDetailSection } from "../section/PurchaseDetailSection/PurchaseDetailSection";
import { Anchor, Box, List, Text, Title } from "@mantine/core";
import { TokenSubscriptionSectionCompact } from "../section/TokenSubscriptionSection/TokenSubscriptionSection";
import { CanceledSubscriptionCard } from "../section/CanceledSubscriptionSection/CanceledSubscriptionSection";
import { DevBadge } from "@components/ui/plan/DevBadge/DevBadge";
import { SelfHostedMoreMenu } from "../section/SelfHostedMenu/SelfHostedMenu";

export default function SelfHostedDevPurchaseCard({
  purchase,
}: IPurchaseCardProps): ReactElement {
  if (purchase.hosted_instance) {
    throw new Error("SelfHostedDevPurchaseCard, purchase is not self-hosted");
  }

  const { token } = purchase;

  if (!token) {
    throw new Error("SelfHostedDevPurchaseCard, token is undefined");
  }

  const isPurchaseCanceledOrDeleted = isCanceledOrDeleted(purchase);

  return (
    <PurchaseCard purchase={purchase}>
      <PurchaseCardHeader
        title={
          <Title m={0} order={2} size="h3">
            Self-hosted
          </Title>
        }
        titleExtra={
          <>
            <DevBadge ml="xs" />
            <Box ml="auto">
              <SelfHostedMoreMenu purchase={purchase} />
            </Box>
          </>
        }
      />
      <Box mt="lg">
        {isPurchaseCanceledOrDeleted ? (
          <CanceledSubscriptionCard
            purchase={purchase}
            extra={<TokenSubscriptionSectionCompact purchase={purchase} />}
          />
        ) : (
          <PurchaseDetailSection
            purchase={purchase}
            extra={
              <TokenSubscriptionSectionCompact purchase={purchase} mt="sm" />
            }
          />
        )}
      </Box>
      {!isPurchaseCanceledOrDeleted && (
        <Box>
          <Text mb="xs" mt="xl">
            Common next steps
          </Text>
          <List>
            <List.Item>
              <Anchor
                href="https://www.metabase.com/learn/metabase-basics/administration/administration-and-operation/multi-env"
                target="_blank"
                rel="noreferrer"
              >
                Learn how to use dev environments
              </Anchor>
            </List.Item>
          </List>
        </Box>
      )}
    </PurchaseCard>
  );
}
